import { client } from 'app/http';

export const updateUserDisabled = async (id: string, oid: string, disabled: boolean) => {
  await client.patch(`/organizations/${oid}/disable-user/${id}`, { disable: disabled });
};
